/*jshint esversion: 6 */
import { inject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { AuthService } from '../../services/authService';
import { UserMessageService } from '../../services/userMessageService';
import { AccountAPI } from '../../services/accountAPI';

@inject(AuthService, Router, AccountAPI, UserMessageService)
export class Account {
  constructor(authService, router, api, userMessageService) {

    this.authService = authService;
    this.router = router;
    this.api = api;
    this.userMessageService = userMessageService;
   
    this.saving = false;
    this.password1 = null;
    this.password2 - null;
    this.email1 = null;
    this.email2 = null;
    this.email_signature = "";
    this.email_signature_text = "";
    this.email_signature_status = false;
    this.isdashboard = false;
    this.dashboardlength = 'col-sm-12';
    this.rout = "";
    this.rout =(localStorage.getItem('rout'))? localStorage.getItem('rout') : ""; 
  }

  attached() {
    this.api.getBusinessTypeList(this.businessTypeSuccess.bind(this), this.saveLoadError.bind(this));
  }

  activate(params) {
    this.showLogoUpload = false;
    this.showLogoUpload2 = false;
    this.loading = true;
    this.defaultBusinessType = 'Select...';
    this.load();
  }

  businessTypeSuccess(list) {
    this.businessTypeList = list;
  }

  load() {
    this.api.getByOwner(
      this.authService.getUser().token,
      this.saveLoadSuccess.bind(this),
      this.saveLoadError.bind(this));
  }

  save() {
    if (this.validate()) {
      this.saving = true;
      this.api.save(
        this.getData(),
        (this.logo_files && this.logo_files.length > 0 && this.showLogoUpload ? this.logo_files[0] : null),
        this.authService.getUser().token,
        this.saveLoadSuccess.bind(this),
        this.saveLoadError.bind(this),
        (this.profile_images && this.profile_images.length > 0 && this.showLogoUpload2 ? this.profile_images[0] : null));
    }
  }

  saveLoadSuccess(data) {
    this.loading = false;
    this.setData(data);
    this.authService.setAccount(data);

    if (this.saving) {
      this.userMessageService.setUserMessage('user', 'Saved!');
    }

    this.saving = false;

    //console.log(this.showLogoUpload2 +"<------>"+ this.logoPath2);
  }

  saveLoadError(msg) {
    this.userMessageService.setUserError('user', msg);
    this.loading = false;
    this.saving = false;
  }

  setData(data) {
    // Note: Keep this method in sync with similar code in affiliate.js
    console.log("account data",data);
    // Basic account fields
    this.orgName = data.org_name;
    this.website = data.website;
    this.orgEmail = data.org_email;
    this.orgPhone = data.org_phone;
    this.logo_file = data.logo_file;
    this.profile_image = data.profile_image;

    if (data.logo_file !== null) {
      this.logoPath = 'api/account/getLogoFile?Authorization=' + this.authService.getUser().token + '&t=' + new Date();
    } else {
      this.logoPath = null;
    }

    if (data.profile_image !== null) {
      this.logoPath2 = 'api/account/getProfileImage?Authorization=' + this.authService.getUser().token + '&t=' + new Date();
    } else {
      this.logoPath2 = null;
    }

    this.showLogoUpload = this.logoPath === null;
    this.showLogoUpload2 = this.logoPath2 === null;
    this.defaultBusinessType = data.business_type;
    this.businessTypeDetail = data.business_type_detail;
    this.mlinkReturnUrl = data.mlink_return_url;

    // Affiliate program fields (preserved here for round-tripping)
    this.accountActive = data.status == '2';
    this.address_1 = data.address_1;
    this.address_2 = data.address_2;
    this.city = data.city;
    this.joined_affiliate_program = data.joined_affiliate_program;
    this.referred_by = data.referred_by;
    this.showAffiliateLink = this.accountActive;
    this.showAffiliateLinkCode = data.joined_affiliate_program !== null;
    this.state = data.state;
    this.zipcode = data.zipcode;
    
    this.first_name = data.first_name;
    this.last_name = data.last_name;

    this.subscription_type = data.subscription_type;

    this.customOpenerPath = data.has_custom_opener ? '/api/account/getCustomOpener?Authorization=' + this.authService.getUser().token + '&t=' + new Date() : null;

    this.email_signature = data.email_signature? data.email_signature : "";
    this.email_signature_text = data.email_signature_text? data.email_signature_text : "";
    this.email_signature_status = data.email_signature_status? true : false;

    this.offset = new Date().getTimezoneOffset();
    if(this.offset<0)
      this.offset = "GMT +"+this.offset/-60;
    else
      this.offset = "GMT -"+this.offset/60;

    this.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    var date = new Date();
    var h = date.getHours();
    var m = date.getMinutes();
    var session = "AM"; 
    
    //conditions for times behavior 
    if ( h == 0 ) {
      h = 12;
    }
    if( h >= 12 ){
      session = "PM";
    }
    
    if ( h > 12 ){
      h = h - 12;
    }
    m = ( m < 10 ) ? m = "0" + m : m;
    this.current_time = h + ":" + m + " " + session;
  }

  getData() {
    // Note: Keep this method in sync with similar code in affiliate.js

    const data = {
      // Basic account fields
      'owner_user_id': this.authService.getUser().id,
      'org_name': this.orgName,
      'org_email': this.orgEmail,
      'org_phone': this.orgPhone,
      'website': this.website,
      'business_type': this.businessType === null ? this.defaultBusinessType : this.businessType.display_value,
      'business_type_detail': (this.businessType !== null && this.businessType.use_detail) || this.businessType === null ? this.businessTypeDetail : null,
      'logo_file': this.logo_file,
      'mlink_return_url': this.mlinkReturnUrl,
      'profile_image': this.profile_image,
      // Affiliate program fields
      'address_1': this.address_1,
      'address_2': this.address_2,
      'city': this.city,
      'joined_affiliate_program': this.joined_affiliate_program,
      'referred_by': this.referred_by,
      'state': this.state,
      'zipcode': this.zipcode,
      'first_name' : this.first_name === null ? null : this.first_name,
      'last_name' : this.last_name === null ? null : this.last_name,

      //Email Signature
      'email_signature' : this.email_signature,
      'email_signature_status' : this.email_signature_status,
      'email_signature_text' : this.email_signature_text
    };

    return data;
  }

  emailSetting() {
    console.log("email signature", this.email_signature_status);
    // this.email_signature_status = !this.email_signature_status;
  }

  findBusinessType(display_value) {
    for (var i = 0; i < this.businessTypeList.length; i++) {
      if (this.businessTypeList[i].display_value == display_value) {
        return this.businessTypeList[i];
      }
    }

    return;
  }

  businessTypeComparer(bt1, bt2) {
    if (bt1 && bt2) {
      return bt1.display_value == bt2.display_value;
    }

    return false;
  }

  validate() {
    var pass = true;

    if (this.orgName === null || this.orgName.trim() == '') {
      this.userMessageService.setUserError('user', 'Organization Name is empty');
      pass = false;
    }

    return pass;
  }

  changePassword() {
    if (this.validatePassword()) {
      this.api.changePassword(
        this.password1,
        this.authService.getUser().token,
        this.changePasswordSuccess.bind(this),
        this.saveLoadError.bind(this));
    }
  }

  changeEmail() {
    if (this.validateEmail()) {
      this.api.changeEmail(
        this.email1,
        this.authService.getUser().token,
        this.changeEmailSuccess.bind(this),
        this.saveLoadError.bind(this));
    }
  }

  changePasswordSuccess() {
    this.userMessageService.setUserMessage('user', 'Password Successfully Updated!');
  }

  changeEmailSuccess() {
    this.userMessageService.setUserMessage('user', 'Email Successfully Updated!');
  }

  validatePassword() {
    var pass = true;

    if (this.password1 === null || this.password1.trim() == '' || this.password2 === null || this.password2.trim() == '') {
      this.userMessageService.setUserError('user', 'Password is empty');
      pass = false;
    }

    if (this.password1 != this.password2) {
      this.userMessageService.setUserError('user', 'Passwords do not match');
      pass = false;
    }

    return pass;
  }

  validateEmail() {
    var pass = true;

    if (this.email1 === null || this.email1.trim() == '' || this.email2 === null || this.email2.trim() == '') {
      this.userMessageService.setUserError('user', 'Email is empty');
      pass = false;
    } else {

      if (!this.is_email(this.email1)) {
        this.userMessageService.setUserError('user', 'Email is not a valid email address');
        pass = false;
      }

      if (this.email1 != this.email2) {
        this.userMessageService.setUserError('user', 'Emails do not match');
        pass = false;
      }
    }

    return pass;
  }

  is_email(email) {
    var emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailReg.test(email);
  }

  showVideoClicked(url) {
    this.showVideo = true;
    this.videoPlayer.src = url;
    this.videoPlayer.load();
    this.videoPlayer.play();
  }

  showVideoClosed() {
      this.showVideo = false;
      if (this.videoPlayer) {
          this.videoPlayer.pause();
      }
  }

  saveCustomOpener() {
    
    if (this.customOpener_files && this.customOpener_files.length > 0) {
      this.saving = true;
    
      this.api.saveCustomOpener(
        this.customOpener_files[0],
        this.authService.getUser().token,
        () => {
          this.saving = false; 
          this.showCustomOpenerUpload = false;
          this.customOpenerPath = '/api/account/getCustomOpener?Authorization=' + this.authService.getUser().token + '&t=' + new Date();
          this.userMessageService.setUserMessage('user', 'Saved!');
        },
        (msg) => {
          this.saving = false; 
      
          this.userMessageService.setUserError('user', msg);
        });
    }
    
  }
  onNavigate() {
    this.navPanelClass = '';
  }

  navigateLink(route, replace = false) {
    console.log("route param",route);
    localStorage.setItem('rout', route);
    if(route.includes("#/user/home") || route == "#/user" || route == "#/user/embed" || route == "#/user/account" || route.includes("#/user/video/request") || route.includes("#/user/video/caseStudy") || route.includes("#/user/video/email"))
    {
      this.isdashboard = true;
      this.dashboardlength = 'col-sm-12';
      console.log("Dashboard value is",this.isdashboard);
      // window.location.href = "Posts?Category=" + sel;
    }
    else
    {
      this.isdashboard = false;
      this.dashboardlength = 'col-sm-9';
      console.log("Dashboard value is",this.isdashboard);
    }
    if(route.includes("#/user/video/email"))
    {
      if(route.includes("upload"))
      route = route + "?captureType=3" + "?videoUpload=1";
      else
      route = route + "?captureType=3";
      // window.location.href = "Posts?Category=" + sel;
    }


    this.router.navigate(route, { replace: replace });
    this.onNavigate();
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }

}
